import Tooltip from '@deprecated-ui/common/Tooltip';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';

function LabelTopUser() {
  return (
    <Tooltip placement="right" title={<p>Stockbit top users</p>}>
      {/* @ts-expect-error */}
      <Button p="0px" margin="0 2px" round>
        <Text size="10px" color={color.suvaGrey} padding="2px">
          TOP
        </Text>
      </Button>
    </Tooltip>
  );
}

export default LabelTopUser;
